import styled from '@emotion/styled';
import { useMediaQuery, useTranslation } from 'src/hooks';
import { transientOptions } from 'src/utils';
import { SvgIcon, Tooltip, Typography } from 'src/components/atoms';
import { Flex } from 'src/components/layout';

type IconName = 'likes' | 'rating';

interface Props {
  name: IconName;
  icon: JSX.Element;
  text: number | string;
}

interface TooltipProps {
  $gridArea: IconName;
}
const StyledTooltip = styled(
  Tooltip,
  transientOptions
)<TooltipProps>(
  ({ $gridArea }) => `
  grid-area: ${$gridArea};
  justify-self: center;
`
);

export const IconWithText = ({ name, icon, text }: Props) => {
  const { t } = useTranslation();
  const matchesMobile = useMediaQuery('sm');

  return (
    <StyledTooltip title={t(`pages.feed.myme.${name}`)} $gridArea={name}>
      <Flex m={matchesMobile ? 0.5 : 1}>
        <SvgIcon sx={{ mr: 0.75, height: 12, width: 12 }}>{icon}</SvgIcon>
        <Typography variant='body2' fontSize={12}>
          {text}
        </Typography>
      </Flex>
    </StyledTooltip>
  );
};
